import {Material} from 'cesium';
import line from '../assets/colors1.png';
class FlowMaterial {
    constructor() {
        this.type = 'FlowMaterial';

        this.addMaterial();
    }

    addMaterial() {
        Material._materialCache.addMaterial(this.type, {
            fabric: {
                type: this.type,
                uniforms: {
                    image: line
                },
                source: `
                czm_material czm_getMaterial(czm_materialInput materialInput)
                   {
                    czm_material material = czm_getDefaultMaterial(materialInput);
                    // float time = czm_frameNumber / 120.0;
                    // vec2 st = materialInput.st;
                    // vec4 colorImage = texture2D(image, vec2(fract(st.s - time), st.t));
                    // material.alpha = colorImage.a;
                    // material.diffuse = colorImage.rgb;
                    material.diffuse = vec4(1.0,0.0,0.0,0.0);
                    return material;
                  }
                `,
            },
        });

        // 注意 defineProperties 会报错，需要改为 Object
        Object.defineProperties(FlowMaterial.prototype, {

        });
    }
    getType() {
        return this.type;
    }

    getValue(time, result) {
        return result;
    }

    equals(other) {
        return (
            this === other ||
            (other instanceof FlowMaterial)
        );
    }

}

export default FlowMaterial;
